import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["timePicker", "dateTimePicker"];
  static values = {
    enableTime: Boolean,
    dateFormat: String,
    noCalendar: Boolean,
    minuteIncrement: Number,
    minDate: String,
  };

  connect() {
    this.initializeTimePickerFlatpickr();
    this.initializeDateTimePickerFlatpickr();
  }

  initializeTimePickerFlatpickr() {
    if (!this.hasTimePickerTarget) return;
    flatpickr(this.timePickerTarget, {
      enableTime: this.enableTimeValue || true,
      noCalendar: this.noCalendarValue || true,
      dateFormat: this.dateFormatValue || "h:i K",
      minuteIncrement: this.minuteIncrementValue || 1,
      minDate: this.minDateValue || "today",
    });
  }

  initializeDateTimePickerFlatpickr() {
    if (!this.hasDateTimePickerTarget) return;
    flatpickr(this.dateTimePickerTarget, {
      enableTime: this.enableTimeValue || true,
      dateFormat: this.dateFormatValue || "F j, Y h:i K",
      minuteIncrement: this.minuteIncrementValue || 1,
      minDate: this.minDateValue || "today",
    });
  }
}
